import React, { useState } from "react";
import styled from "styled-components";
import { useHistory, useLocation } from "react-router-dom";

//components
import { NewBackButton } from "../../../../components/svgs";
import { DynamicButton } from "../../../../components/common/basic";

// theme
import { useTheme } from "../../../../hooks";
import { OfferAlertModal } from "../../../../components/loyalty";
import { useSpinTheWheelHome } from "../hooks";

const RedemptionOnground = () => {
  const [redemptionCode, setRedemptionCode] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const [isProcessingRedemption, setProcessingRedemption] = useState(false);
  const [showModalUnavailable, setModalUnavailable] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [unavailableMsg, setModalUnavailableMsg] = useState();
  const [showModalQualified, setModalQualified] = useState(false);
  const [modalQualifiedMessage, setModalQualifiedMessage] = useState("");
  const [showTriviaRatingModal, setShowTriviaRatingModal] = useState(false);
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const params = Object.fromEntries(searchParams);
  const { id } = params || {};

  const {
    redeemOrder,
    userHistory,
    getItemFromStock,
    getSpinTheWheel,
  } = useSpinTheWheelHome();

  const selectedItem = userHistory?.find(item => id === item._id)
  const { name, imageUrl } = getItemFromStock(selectedItem?.itemCode) || {};
  const { themeContext, theme } = useTheme();

  let history = useHistory();

  const goHome = () => {
    history.push("/home?token=" + JSON.parse(localStorage.getItem("token")));
  };

  let mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];
  const themeColor = theme.colors[themeContext.activeTheme]["background"];

  const submitRedemptionCode = (e) => {
    e?.preventDefault();
    if (redemptionCode != '124') {
      setErrorMessage("Invalid redemption code!")
      return;
    }
    setProcessingRedemption(true);
    redeemOrder(
      id,
      (data) => {
        setProcessingRedemption(false);
        if (data?.success) {
          setErrorMessage(null);
          setModalQualified(true);
          getSpinTheWheel();
        } else {
          setErrorMessage(data?.message || "An unexpected error occurred")
        }
      }
    )
  }

  return (
    <>
      <MainHolder>
        <Children>
          <div
            style={{
              width: "55%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <BackButtonContainer
              onClick={() => history.goBack()}
              style={{ zIndex: 100, marginLeft: 20 }}
            >
              <NewBackButton />
            </BackButtonContainer>
          </div>
          <DescriptionBody color={mashupBackground}>
            <div style={{ padding: "20px", }}>
              <h2 style={{ fontFamily: "MTNRegular" }}>Congratulations, it's time to claim your reward!</h2>
              <p style={{ fontFamily: "MTNRegular", marginBottom: "30px" }}>Collect your rewards from an MTN representative at the event location.</p>
              <form onSubmit={submitRedemptionCode}>
                <label style={{ fontFamily: "MTNRegular" }}>Enter redemption code (Staff only):</label>
                <input
                  type='password'
                  value={redemptionCode}
                  onChange={(e) => { setRedemptionCode(e.target.value) }}
                  style={{
                    fontFamily: "MTNRegular",
                    fontSize: "2.3em",
                    textAlign: "center",
                    marginTop: "10px",
                    marginBottom: "10px",
                    color: "#000",
                    width: "100%",
                    border: `1px solid ${themeColor}`,
                    boxSizing: "border-box",
                    background: "none",
                  }}
                />
                <DynamicButton
                  onClick={submitRedemptionCode}
                  label={isProcessingRedemption ? "Processing..." : "Submit"}
                  fullWidth
                  disabled={isProcessingRedemption}
                  color={themeColor}
                />
              </form>
              {
                (!isProcessingRedemption && errorMessage) ?
                  <p style={{ fontFamily: "MTNRegular", marginBottom: "30px", color: "red", textAlign: "center" }}>{errorMessage}</p>
                  : <></>
              }

            </div>

          </DescriptionBody>
        </Children>
      </MainHolder>

      {
        showModalUnavailable && (
          <OfferAlertModal
            background={themeColor}
            hideModal={() => {
              setModalUnavailable(false);
              goHome();
            }}
            title='Trivia not available'
            description={unavailableMsg}
          />
        )
      }
      {
        showModalQualified && (
          <OfferAlertModal
            background={themeColor}
            hideModal={() => {
              setModalQualified(false)
              setShowTriviaRatingModal(true);
              goHome();
            }}
            title={"Congratulations"}
            description={"Redemption successful!"}
          />
        )
      }
    </>
  );
};


const MainHolder = styled.div`
  overflow: hidden;
  scrollbar-width: none;
  /* background-color: ${({ activeTheme }) => activeTheme}; */
  background-color: white;
  height: 700px;
  position: relative;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Children = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  //   position: absolute;
  margin: 8px;
`;

const DescriptionBody = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background-color: ${({ color }) => color};
  align-items: center;
`;

const ContentHolder = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: "5px";
`;

const ViewAllHolder = styled.div`
  text-align: center;
  cursor: pointer;
`;

const HistoryContainer = styled.div`
  width: 80%;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  margin: 20px;
  padding: 15px;
  overflow: auto;
`;

export default RedemptionOnground;
